import React from 'react';

import CreatePrescriptionTrigger from 'triggers/CreatePrescriptionTrigger';
import ScriptTypeToggleContainer from 'common/ScriptTypeToggleContainer';
import ScriptListContainer from 'manage/ScriptListContainer';
import ManageFiltersContainer from 'manage/ManageFiltersContainer';

import classNames from 'classnames';


const baseString = 'vra-manage-display-panel';
const classString = classNames({
  [`${baseString}`]: true
});
const sectionProps = {
  'data-test-id': 'vra-management-display-panel',
  'data-title': 'Script Management',
  className: classString
};

const ManagementDisplayPanel = ({
  ...props
}) => (
  <section {...sectionProps}>
    <ManageFiltersContainer />
    <ScriptTypeToggleContainer />
    <ScriptListContainer/>
    <footer className={`${baseString}__footer`}>
      <CreatePrescriptionTrigger {...props} />
    </footer>
  </section>
);
export default ManagementDisplayPanel;
